<template>
  <a-dropdown 
    :trigger="['click']" 
    :visible="visible"
    @visibleChange="handleVisibleChange"
  >
    <a class="ant-dropdown-link" @click.prevent>
      <a-icon type="global" style="margin-right: 4px"/>
      {{ currentLanguage }} <a-icon type="down"/>
    </a>
    <template slot="overlay">
      <div 
        @mouseenter="clearCloseTimer"
        @mouseleave="startCloseTimer"
      >
        <a-menu @click="handleLanguageChange">
          <a-menu-item key="zh-CN">
            <span role="img" aria-label="中文">🇨🇳</span> 中文
          </a-menu-item>
          <a-menu-item key="en-US">
            <span role="img" aria-label="English">🇺🇸</span> English
          </a-menu-item>
          <a-menu-item key="id-ID">
            <span role="img" aria-label="Bahasa Indonesia">🇮🇩</span> Bahasa Indonesia
          </a-menu-item>
        </a-menu>
      </div>
    </template>
  </a-dropdown>
</template>

<script>
export default {
  name: 'LanguageSwitch',
  data() {
    return {
      visible: false,
      closeTimer: null
    }
  },
  computed: {
    currentLanguage() {
      const languageMap = {
        'zh-CN': '中文',
        'en-US': 'English',
        'id-ID': 'Bahasa'
      }
      return languageMap[this.$i18n.locale] || 'Language'
    }
  },
  methods: {
    handleLanguageChange({ key }) {
      this.$i18n.locale = key
      localStorage.setItem('user_language', key)
      this.visible = false
    },
    handleVisibleChange(visible) {
      this.visible = visible
      if (!visible) {
        this.clearCloseTimer()
      }
    },
    startCloseTimer() {
      this.clearCloseTimer()
      this.closeTimer = setTimeout(() => {
        this.visible = false
      }, 100) // 1秒后自动关闭
    },
    clearCloseTimer() {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer)
        this.closeTimer = null
      }
    }
  },
  beforeDestroy() {
    this.clearCloseTimer()
  }
}
</script>

<style scoped>
.ant-dropdown-link {
  color: rgba(0, 0, 0, 0.65);
  transition: all 0.3s;
  padding: 0 12px;
  display: inline-block;
  height: 100%;
}
.ant-dropdown-link:hover {
  /* color: #1890ff; */
}
</style>


// WEBPACK FOOTER //
// src/components/LanguageSwitch.vue